import '../css/Customize.css'

const LAYOUTS = [
   {
      id: 0,
      label: '1',
      preview: (
         <svg viewBox="0 0 60 80" fill="none">
            <rect
               x="4"
               y="4"
               width="52"
               height="18"
               rx="2"
               fill="currentColor"
               opacity=".8"
            />
            <rect
               x="4"
               y="26"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="4"
               y="35"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="4"
               y="44"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="4"
               y="55"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
            <rect
               x="4"
               y="64"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
         </svg>
      ),
   },
   {
      id: 1,
      label: '2',
      preview: (
         <svg viewBox="0 0 60 80" fill="none">
            <rect
               x="4"
               y="4"
               width="20"
               height="72"
               rx="2"
               fill="currentColor"
               opacity=".6"
            />
            <rect
               x="28"
               y="4"
               width="28"
               height="8"
               rx="1"
               fill="currentColor"
               opacity=".8"
            />
            <rect
               x="28"
               y="16"
               width="28"
               height="5"
               rx="1"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="28"
               y="24"
               width="28"
               height="5"
               rx="1"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="28"
               y="33"
               width="28"
               height="5"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
            <rect
               x="28"
               y="41"
               width="28"
               height="5"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
            <rect
               x="28"
               y="50"
               width="28"
               height="5"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
         </svg>
      ),
   },
   {
      id: 2,
      label: '3',
      preview: (
         <svg viewBox="0 0 60 80" fill="none">
            <rect
               x="4"
               y="4"
               width="52"
               height="22"
               rx="2"
               fill="currentColor"
               opacity=".8"
            />
            <rect
               x="4"
               y="30"
               width="24"
               height="46"
               rx="2"
               fill="currentColor"
               opacity=".5"
            />
            <rect
               x="32"
               y="30"
               width="24"
               height="20"
               rx="1"
               fill="currentColor"
               opacity=".3"
            />
            <rect
               x="32"
               y="54"
               width="24"
               height="20"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
         </svg>
      ),
   },
   {
      id: 3,
      label: '4',
      preview: (
         <svg viewBox="0 0 60 80" fill="none">
            <circle cx="30" cy="14" r="10" fill="currentColor" opacity=".8" />
            <rect
               x="4"
               y="28"
               width="52"
               height="6"
               rx="1"
               fill="currentColor"
               opacity=".6"
            />
            <rect
               x="4"
               y="38"
               width="24"
               height="38"
               rx="2"
               fill="currentColor"
               opacity=".35"
            />
            <rect
               x="32"
               y="38"
               width="24"
               height="18"
               rx="1"
               fill="currentColor"
               opacity=".25"
            />
            <rect
               x="32"
               y="60"
               width="24"
               height="16"
               rx="1"
               fill="currentColor"
               opacity=".2"
            />
         </svg>
      ),
   },
]

const ACCENT_COLORS = [
   { label: 'Gold', value: '#d4a843' },
   { label: 'Teal', value: '#2dd4bf' },
   { label: 'Rose', value: '#fb7185' },
   { label: 'Violet', value: '#a78bfa' },
   { label: 'Slate', value: '#94a3b8' },
   { label: 'Jade', value: '#4ade80' },
]

const HEADER_COLORS = [
   { label: 'Charcoal', value: '#1e1e2e' },
   { label: 'Navy', value: '#1e3a5f' },
   { label: 'Forest', value: '#1a3a2a' },
   { label: 'Burgundy', value: '#3a1a1a' },
   { label: 'Ink', value: '#0f172a' },
   { label: 'Stone', value: '#292524' },
]

const FONT_PAIRS = [
   {
      label: 'Classic',
      body: 'Georgia, serif',
      heading: 'Playfair Display, serif',
   },
   { label: 'Modern', body: 'Inter, sans-serif', heading: 'Inter, sans-serif' },
   {
      label: 'Editorial',
      body: 'Lato, sans-serif',
      heading: 'Cormorant Garamond, serif',
   },
   {
      label: 'Technical',
      body: 'IBM Plex Sans, sans-serif',
      heading: 'IBM Plex Mono, monospace',
   },
   { label: 'Elegant', body: 'EB Garamond, serif', heading: 'Cinzel, serif' },
]

const PenIcon = () => (
   <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5">
      <path d="M2 12l8-8 2 2-8 8H2v-2z" />
      <path d="M12 2l2 2" />
   </svg>
)

function SwatchRow({ colors, active, onSelect, colorKey }) {
   return (
      <div className="swatch-row">
         {colors.map(c => (
            <button
               key={c.value}
               className={`swatch${active === c.value ? ' active' : ''}`}
               style={{ '--swatch-color': c.value }}
               onClick={() => onSelect(colorKey, c.value)}
               title={c.label}
            />
         ))}
         <label className="swatch swatch-custom" title="Custom color">
            <input
               type="color"
               value={active || '#000'}
               onChange={e => onSelect(colorKey, e.target.value)}
            />
            <PenIcon />
         </label>
      </div>
   )
}

function Customize({ design, designHandler }) {
   const set = (key, value) =>
      designHandler(prev => ({ ...prev, [key]: value }))

   return (
      <div className="customize">
         {/* Layout */}
         <div className="c-section">
            <p className="c-label">Layout</p>
            <div className="layout-grid">
               {LAYOUTS.map(l => (
                  <button
                     key={l.id}
                     className={`layout-card${design.layout === l.id ? ' active' : ''}`}
                     onClick={() => set('layout', l.id)}
                     title={`Layout ${l.label}`}>
                     <div className="layout-preview">{l.preview}</div>
                     <span className="layout-num">{l.label}</span>
                  </button>
               ))}
            </div>
         </div>

         {/* Accent Color */}
         <div className="c-section">
            <p className="c-label">Accent Color</p>
            <SwatchRow
               colors={ACCENT_COLORS}
               active={design.accentColor}
               onSelect={set}
               colorKey="accentColor"
            />
         </div>

         {/* Header Color */}
         <div className="c-section">
            <p className="c-label">Header Background</p>
            <SwatchRow
               colors={HEADER_COLORS}
               active={design.headerColor}
               onSelect={set}
               colorKey="headerColor"
            />
         </div>

         {/* Font */}
         <div className="c-section">
            <p className="c-label">Font Style</p>
            <div className="font-list">
               {FONT_PAIRS.map((f, i) => (
                  <button
                     key={f.label}
                     className={`font-card${design.fontPair === i ? ' active' : ''}`}
                     onClick={() => set('fontPair', i)}>
                     <span className="font-label">{f.label}</span>
                     <span
                        className="font-preview"
                        style={{ fontFamily: f.heading }}>
                        Aa
                     </span>
                  </button>
               ))}
            </div>
         </div>

         {/* Spacing */}
         <div className="c-section">
            <p className="c-label">
               Spacing <span className="c-value">{design.spacing ?? 1}×</span>
            </p>
            <input
               type="range"
               min="0.7"
               max="1.5"
               step="0.05"
               value={design.spacing ?? 1}
               onChange={e => set('spacing', parseFloat(e.target.value))}
               className="c-slider"
            />
         </div>

         {/* Header Font Size */}
         <div className="c-section">
            <p className="c-label">
               Header Font Size{' '}
               <span className="c-value">{design.fontSizeHeader ?? 13}px</span>
            </p>
            <input
               type="range"
               min="10"
               max="20"
               step="0.5"
               value={design.fontSizeHeader ?? 13}
               onChange={e => set('fontSizeHeader', parseFloat(e.target.value))}
               className="c-slider"
            />
         </div>

         {/* Body Font Size */}
         <div className="c-section">
            <p className="c-label">
               Body Font Size{' '}
               <span className="c-value">{design.fontSize ?? 13}px</span>
            </p>
            <input
               type="range"
               min="10"
               max="16"
               step="0.5"
               value={design.fontSize ?? 13}
               onChange={e => set('fontSize', parseFloat(e.target.value))}
               className="c-slider"
            />
         </div>

         {/* Show Photo */}
         <div className="c-section c-row">
            <p className="c-label" style={{ marginBottom: 0 }}>
               Show Photo
            </p>
            <button
               className={`toggle${design.showPhoto !== false ? ' on' : ''}`}
               onClick={() => set('showPhoto', !design.showPhoto)}>
               <span className="toggle-knob" />
            </button>
         </div>
      </div>
   )
}

export { FONT_PAIRS }
export default Customize
